import {QuestionComponent} from './QuestionComponent'
import {Matrix} from 'app/models/questions/Matrix'
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms'
import {
  HoneyPotComponent
} from "../../modules/survey/survey-viewer/survey-question/types/honey-pot/honey-pot.component";

export class HoneyPot extends Matrix {
    getDisplayComponent() {
        return new QuestionComponent(HoneyPotComponent, this)
    }

    buildStatementFormGroup(): UntypedFormGroup {
        const form = new UntypedFormGroup({})

        this.statementKeys.forEach(sKey => {
            form.addControl(
                sKey,
                new UntypedFormControl(
                    true,
                    {
                        // updateOn: 'blur', // <---- Évite la sauvegarde vers firebase de manière intensive...
                    }
                ),
            )
        })
        return form
    }
}
